module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowDown_white.b55bbc06.svg";